import React from "react";

const NAV_TABS = [
  { id: "home", icon: "🏠", label: "Home" },
  { id: "school", icon: "🏫", label: "School & Activities" },
  { id: "links", icon: "🔗", label: "Quick Links" },
  { id: "essential", icon: "🔒", label: "Essential Info" },
];

const LINK_TILES = [
  { icon: "🛒", label: "Shopping", type: "internal", page: "shopping", bg: "#EAF4EA", color: "#3A7A3E" },
  { icon: "✈️", label: "Trips", type: "internal", page: "trips", bg: "#EEF0FA", color: "#5A6AB0" },
  { icon: "🪣", label: "Bucket List", type: "internal", page: "bucket-list", bg: "#EAF4EA", color: "#3A7A3E" },
  { icon: "🎁", label: "Gifts", type: "internal", page: "gifts", bg: "#FAF0F0", color: "#A05050" },
  { icon: "💾", label: "Family Projects", type: "internal", page: "family-projects", bg: "#F2F0ED", color: "#7A6A50" },
  { icon: "📂", label: "Drive Links", type: "internal", page: "drive-links", bg: "#E8F0FE", color: "#3367D6" },
  { icon: "🌱", label: "Gardening", type: "external", url: "https://app.notion.com/p/310a240407da4ac7a3e713af0357ac09", bg: "#EAF4EA", color: "#3A7A3E" },
  { icon: "🗂️", label: "Notion Home", type: "external", url: "https://app.notion.com/p/86faec99a8a94b01b21dbd18edac817e", bg: "#F2F0ED", color: "#4A4A4A" },
];

export default function QuickLinksPage({ onTabTap, onPageTap }) {
  return (
    <div className="app">
      <header style={{ background: "var(--white)", padding: "54px 20px 16px", borderBottom: "1px solid var(--border)" }}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 600, color: "var(--charcoal)" }}>
          Quick <span style={{ position: "relative" }}>Links<span style={{ position: "absolute", bottom: -2, left: 0, width: "100%", height: 2, background: "var(--sage)", borderRadius: 2 }} /></span>
        </div>
      </header>

      <div className="scroll-body" style={{ padding: "16px 16px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {LINK_TILES.map(tile => {
            const handleTap = () => {
              if (tile.type === "internal") onPageTap?.(tile.page);
              else window.open(tile.url, "_blank", "noreferrer");
            };
            return (
              <div key={tile.label} onClick={handleTap} style={{ background: "var(--white)", borderRadius: 16, border: "1px solid var(--border)", padding: "20px 16px", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.05)", minHeight: 110 }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, background: tile.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>{tile.icon}</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "var(--charcoal)" }}>{tile.label}</div>
              </div>
            );
          })}
        </div>
      </div>

      <nav style={{ position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: "var(--app-max-width)", background: "var(--white)", borderTop: "1px solid var(--border)", display: "flex", padding: "10px 0 20px", zIndex: 100 }}>
        {NAV_TABS.map(t => (
          <div key={t.id} onClick={() => onTabTap?.(t.id)} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3, cursor: "pointer", padding: "4px 0" }}>
            <div style={{ fontSize: 22 }}>{t.icon}</div>
            <div style={{ fontSize: 10, fontWeight: t.id === "links" ? 800 : 700, color: t.id === "links" ? "var(--sage)" : "var(--muted)", textAlign: "center", lineHeight: 1.2 }}>{t.label}</div>
            {t.id === "links" && <div style={{ width: 4, height: 4, borderRadius: "50%", background: "var(--sage)", marginTop: 1 }} />}
          </div>
        ))}
      </nav>
    </div>
  );
}
